/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Admin_Granted_DescInputs */



/**
* | output |
* | --- |
* | "The member is now an organisation admin and can change organisation-wide settings, manage members and read the audit log." |
*
* @param {Audit_Details_Member_Admin_Granted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_admin_granted_desc = /** @type {((inputs?: Audit_Details_Member_Admin_Granted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Admin_Granted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied ist jetzt Organisations-Admin und kann organisationsweite Einstellungen ändern, Mitglieder verwalten und das Audit-Log lesen.")
	return /** @type {LocalizedString} */ ("The member is now an organisation admin and can change organisation-wide settings, manage members and read the audit log.")
});